import API_END_POINTS from '../../../api/endpoints';
import { dataFetch } from '../../../api/data-fetch';

const state = () => {
  return {
    promotions: [],
    promotionsList: [],
    tcsModalActive: false,
    tcsModalText: '',
  };
};

// actions
const actions = {
  async fetchPromotionsByEventId(state, eventId, fetcher = dataFetch) {
    const endpoint = `${API_END_POINTS.BETTING_PROMOTIONS}&brand=punters&eventId=${eventId}`;
    const res = await fetcher(endpoint);
    state.commit('SET_BETTING_PROMOTIONS_LIST', res.promotions);
  },

  async fetchPromotionsList(state, fetcher = dataFetch) {
    const endpoint = `${API_END_POINTS.BETTING_PROMOTIONS_LIST}`;
    const res = await fetcher(endpoint);
    state.commit('SET_BETTING_PROMOTIONS_LIST', res.promotions);
  },

  toggleModalStatus(state, { isActive, text }) {
    state.commit('SET_MODAL_TEXT', text);
    state.commit('SET_MODAL_STATUS', isActive);
  },
};

// mutations
const mutations = {
  SET_BETTING_PROMOTIONS: (state, deals) => {
    state.promotions = deals;
  },
  SET_BETTING_PROMOTIONS_LIST: (state, list) => {
    state.promotionsList = list;
  },
  SET_MODAL_STATUS: (state, value) => {
    state.tcsModalActive = value;
  },
  SET_MODAL_TEXT: (state, text) => {
    state.tcsModalText = text;
  },
};

// getters
const getters = {
  getBettingPromotions: state => {
    return state.promotions;
  },
  getBettingPromotionsList: state => {
    return state.promotionsList;
  },
  getTCsModalStatus: state => {
    return state.tcsModalActive;
  },
  getTCsModalText: state => {
    return state.tcsModalText;
  },
};

export default {
  namespaced: true,
  actions,
  mutations,
  state,
  getters,
};
